//Library Imports
import React, { useEffect, useState } from "react";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//Local Imports
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import SentEmailSearch from "../../Campaigns/Emails/Components/SentEmailSearch";
import FilterDropdownPersonality from "../../Campaigns/Audience/People/FilterDropdownPersonality";
import tickOnGroupIcon from "../../../assets/img/icons/tickOnGroupIcon.svg";
import GroupList from "./GroupList";

//Style Imports
import styled from "styled-components";
import { getQuerySalesXGroupId } from "utils";
import {
  addUsersInGroups,
  getSalesXGroupDetails,
  getSalesXGroupUsersAction,
  removeUsersFromGroups,
  resetSelectedGroup,
  resetSelectedGroupUsers,
  resetUsers,
  updateGroupCount,
} from "../actions";
import PersonalityFilterWithApply from "modules/Common/Components/PersonalityFilterWithApply";
import { SALESX_GROUP_DETAIL } from "constants/types/groupTypes";
import { getQueryCampaignId, getQueryEmailId, getQueryExportPopup } from "modules/EmailBrowser/utils";
import { addGillRoyIcon, removeGillRoyIcon } from "utils";
import ConfirmDialogWithModal from "modules/Common/Components/ConfirmDialogWithModal";
import { getQueryNewGroup } from "../utils";

const GroupPage: React.FC = () => {
  // useQuery
  const queryParamSalesxGroupId = getQuerySalesXGroupId();
  const queryExportPopup = getQueryExportPopup();

  // Redux States
  const users = useSelector((state: RootState) => state.salesXGroups.usersData.users);
  const totalUsers = useSelector((state: RootState) => state.salesXGroups.usersData.totalCount);
  const selectedUser = useSelector((state: RootState) => state.salesXGroups.selectedGroup.users);
  const selectedGroupId = useSelector((state: RootState) => state.salesXGroups.selectedGroup.groupId);
  const globalListing = useSelector((state: RootState) => state.salesXGroups.selectedGroup.showGlobalListing);
  const totalSelectedGroupUsers = useSelector((state: RootState) => state.salesXGroups.selectedGroup.totalCount);
  const selectedGroup = useSelector((state: RootState) => state.salesXGroups.selectedGroup);
  const selectedUsersLoading = useSelector((state: RootState) => state.salesXGroups.selectedGroup.loading);

  ///Local States
  const history = useHistory();
  const [showDialog, setShowDialog] = useState(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedPersonalityType, setSelectedPersonalityType] = useState<string[]>([]);
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const [checkedItems, setCheckedItems]: any[] = useState([]);
  const [selectAllExcept, setSelectAllExcept]: any = useState([]);
  const [selectAllFlag, setSelectAllFlag] = useState(false);

  // Local Variables
  const limit = 10;

  const resetSelection = () => {
    setSelectAllExcept([]);
    setSelectAllFlag(false);
    setCheckedItems([]);
  };

  // FUNCTIONS
  const searchHandler = (searchValue: string) => {
    setSearchValue(searchValue);
    if (globalListing) {
      resetUsers();
    } else {
      resetSelectedGroupUsers();
    }
    if (globalListing) {
      getSalesXGroupUsersAction({
        limit,
        offset: 0,
        searchTerm: searchValue,
        ...(appliedFilters.length === 0 ? {} : { personalityType: appliedFilters.join(",") }),
        groupId: queryParamSalesxGroupId,
      });
    } else {
      getSalesXGroupDetails({
        groupId: queryParamSalesxGroupId,
        limit: 10,
        offset: 0,
        ...(appliedFilters.length === 0 ? {} : { personalityType: appliedFilters.join(",") }),
        searchTerm: searchValue,
      });
    }
    resetSelection();
    // if (searchValue.trim().length > 0 || filterType.length > 0)
    //   getUserWorkflows(0, limit, searchValue, filterType);
    // else {
    //   store.dispatch({
    //     type: AUTOMATION_USER_WORKFLOWS.SET_SEARCH_TERM,
    //     payload: searchValue,
    //   });
    // }
  };

  const resetSearchHandler = () => {
    console.log({ appliedFilters });
    if (globalListing) {
      resetUsers();
    } else {
      resetSelectedGroupUsers();
    }
    setSearchValue("");
    if (globalListing) {
      getSalesXGroupUsersAction(
        {
          limit,
          offset: 0,
          groupId: queryParamSalesxGroupId,
          // ...(globalListing ? {} : { groupId: getQuerySalesXGroupId() }),
          ...(appliedFilters.length === 0 ? {} : { personalityType: appliedFilters.join(",") }),
        },
        globalListing ? false : true
      );
    } else {
      getSalesXGroupDetails({
        limit,
        offset: 0,
        groupId: queryParamSalesxGroupId,
        ...(appliedFilters.length === 0 ? {} : { personalityType: appliedFilters.join(",") }),
      });
    }

    resetSelection();

    // if (filterType.length > 0) getUserWorkflows(0, limit, "", filterType);
    // store.dispatch({
    //   type: AUTOMATION_USER_WORKFLOWS.SET_SEARCH_TERM,
    //   payload: "",
    // });
  };

  const handleOnClickAddUsers = () => {
    setSelectedPersonalityType([]);
    setAppliedFilters([]);
    resetUsers();
    resetSelection();
    setSearchValue("");
    store.dispatch({ type: SALESX_GROUP_DETAIL.GLOBAL_LISTING, payload: true });
    getSalesXGroupUsersAction({ groupId: queryParamSalesxGroupId, limit, offset: 0 });
    // history.push(`/groups/group-list?group_id=${queryParamSalesxGroupId}`);
  };
  const handleOnClickSave = () => {
    addUsersInGroups(
      selectedGroup.groupId,
      selectAllFlag,
      checkedItems,
      selectAllExcept,
      searchValue,
      appliedFilters
    ).then(() => {
      if (totalSelectedGroupUsers === 0) {
        //When a new group os created update count in global listing
        updateGroupCount(
          selectedGroup.groupId,
          selectAllFlag ? total : selectAllExcept.length > 0 ? total - selectAllExcept.length : checkedItems.length
        );
      }
      setShowDialog(true);
    });
  };

  const onClickViewGroups = () => {
    setShowDialog(false);
    if (queryExportPopup === 'true') {
      let search = window.location.search;
      history.push(`/groups${search}`)
    } else {
      history.push(`/groups`);
    }
  };

  const onClickOk = () => {
    setShowDialog(false);
    setSearchValue("");
    resetSelection();
    setSelectedPersonalityType([]);
    setAppliedFilters([]);
    resetSelectedGroup();
    onAddSuccess();
    if (selectAllFlag) setSelectAllFlag(false);
  };
  const resetFilters = () => {
    setSelectedPersonalityType([]);
    // store.dispatch({
    //   type: AUDIENCE_LISTS_PROFILED_CONTACTS.SET_FILTERS,
    //   filters: {
    //     personality: [],
    //   },
    // });
  };
  const clearFiltersHandler = () => {
    //  resetFilters();
    // exportPeopleFiltersUpdate(); // reset the filters in the store for export
    // setClearFiltersCheck(!clearFiltersCheck);
    // resetAudienceListDetailsProfiled(); // reset list contacts on clear filters
    // if (audienceFiltersApplied) {
    //   store.dispatch({
    //     type: GLOBAL_ACTION.AUDIENCE_FILTERS_APPLIED,
    //     payload: false,
    //   });
    // }
  };

  const total = globalListing ? totalUsers : totalSelectedGroupUsers;

  // useEffect hooks
  useEffect(() => {
    if (globalListing) {
      getSalesXGroupUsersAction({ limit: 10, offset: 0, groupId: queryParamSalesxGroupId });
    } else if (!selectedUsersLoading) {
      getSalesXGroupDetails({ groupId: queryParamSalesxGroupId, limit: 10, offset: 0 });
    }
    return () => {
      resetSelectedGroup();
    };
  }, []);

  useEffect(() => {
    if (checkedItems.length > 0 || selectAllFlag) removeGillRoyIcon();
    else addGillRoyIcon();
  }, [checkedItems]);

  const redirectToPublish = () => {
    let campaignId = getQueryCampaignId();
    let emailId = getQueryEmailId();
    let newGroup = getQueryNewGroup();
    resetUsers();
    let queryParams = new URLSearchParams(window.location.search);
    let redirectURL = `/campaigns/editionedit/publish/?campaign_id=${campaignId}&email_id=${emailId}&exportPopup=true`;
    if (queryParams.has('newGroup') && queryParams.get('newGroup') === 'true') {
    } else {
      redirectURL += '&group_id=' + queryParamSalesxGroupId;
    }
    history.push(`${redirectURL}${newGroup ? '&newGroup=' + newGroup : ''}`);
  };
  const handleApplyFilter = () => {
    resetSelectedGroupUsers();
    resetSelection();
    setAppliedFilters([...selectedPersonalityType]);
  };

  const onAddSuccess = () => {
    let isExportPopup = getQueryExportPopup();

    if (isExportPopup === "true") {
      redirectToPublish();
    } else {
      store.dispatch({ type: SALESX_GROUP_DETAIL.GLOBAL_LISTING, payload: false });
      getSalesXGroupDetails({ groupId: queryParamSalesxGroupId, limit: 10, offset: 0 });
    }
  };

  const removeUsersHandler = (e: any) => {
    removeUsersFromGroups(
      selectedGroup.groupId,
      selectAllFlag,
      checkedItems,
      selectAllExcept,
      searchValue,
      appliedFilters
    ).then(() => {
      resetSelection();
    });
  };

  const addUsersHandler = (e: any) => {
    addUsersInGroups(
      selectedGroup.groupId,
      selectAllFlag,
      checkedItems,
      selectAllExcept,
      searchValue,
      appliedFilters
    ).then(() => {
      if (totalSelectedGroupUsers === 0) {
        //When a new group os created update count in global listing
        updateGroupCount(
          selectedGroup.groupId,
          selectAllFlag ? total : selectAllExcept.length > 0 ? total - selectAllExcept.length : checkedItems.length
        );
      }
      setShowDialog(true);
    });
  };

  return (
    <Wrapper>
      <div className="wrapper-listing">
        <div className="d-flex justify-content-between pt-3 headerRow">
          <div className="pe-3 search-group-page">
            <SentEmailSearch
              value={searchValue}
              handleSearch={searchHandler}
              reset={resetSearchHandler}
              placeholder="Search for Email/Name"
            />
          </div>

          {globalListing ? (
            // Save Button
            <ButtonRightIconGreen
              idBtn="group-save-qa"
              label="Save"
              noIcon={true}
              classIcon="plus15"
              classBtn={`save-btn ${checkedItems.length > 0 ||
                (selectAllExcept.length > 0 &&
                  selectAllExcept.length !== (globalListing ? totalUsers : totalSelectedGroupUsers)) ||
                selectAllFlag
                ? ""
                : "disabled disabled-style"
                }`}
              onClick={handleOnClickSave}
            />
          ) : (
            // Add Users Button
            <ButtonRightIconGreen
              idBtn="group-save-qa"
              label="Add Users"
              noIcon={true}
              classIcon="plus15"
              classBtn="add-users-btn"
              disabled={!selectedGroup.isDeletable}
              onClick={() => handleOnClickAddUsers()}
            />
          )}
        </div>
        <div className="d-flex justify-content-between header-2nd-row">
          <div className={`personality-dropdwon`} id="personality-dropdwon-qa">
            <PersonalityFilterWithApply
              selectedPersonalityType={selectedPersonalityType}
              setSelectedPersonalityType={setSelectedPersonalityType}
              handleApply={handleApplyFilter}
              totalUsers={total}
            />
          </div>
          <div className="count-search">
            {checkedItems.length > 0
              ? `${selectAllFlag
                ? total
                : selectAllExcept.length > 0
                  ? total - selectAllExcept.length
                  : checkedItems.length
              }/`
              : null}
            {globalListing ? totalUsers : totalSelectedGroupUsers} Total
          </div>
        </div>
        <div className="d-flex flex-column group-content-inner">
          {showDialog ? (
            <ConfirmDialogWithModal
              icon={tickOnGroupIcon}
              confirm="Ok"
              cancel="View groups"
              titleQuestion="Group saved successfully!"
              title={null}
              descriptions={null}
              className="confirmDialogBox dialogStyles"
              onCancel={onClickViewGroups}
              onConfirm={onClickOk}
            />
          ) : null}

          <GroupList
            searchTerm={searchValue}
            personalityFilters={appliedFilters}
            setSearchTerm={setSearchValue}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            selectAllExcept={selectAllExcept}
            setSelectAllExcept={setSelectAllExcept}
            selectAllFlag={selectAllFlag}
            setSelectAllFlag={setSelectAllFlag}
            addUsersHandler={addUsersHandler}
            removeUsersHandler={removeUsersHandler}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default GroupPage;

const Wrapper = styled.div`
  .search-group-page {
    width: 700px;
  }
  .header-2nd-row {
    margin-top: 24px;
    margin-bottom: 15px;
  }
  .count-search {
    color: #5e7079;
    font-family: "Roboto Slab", serif;
    font-size: 16px;
    font-weight: 700;
    padding-top: 6px;
    display: inline-block;
    white-space: nowrap;
  }
  .personality-dropdwon {
    .custom-select__trigger {
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 34px;
        display: block;
        padding: 10px 35px 10px 10px;
      }
    }
    .arrow-dropdown {
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: 10px;
      }
    }
  }
  .save-btn {
    padding: 4px 16px 4px 24px;
    font-family: "Helvetica";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
    border-radius: 8px;
  }
  .add-users-btn {
    padding: 4px 16px 4px 24px;
    font-family: "Helvetica";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }
  .headerRow > button > span {
    min-width: 85px;
  }
  .confirmDialogBox {
    width: 326px;
    .message {
      font-family: "Roboto Slab";
      font-style: normal;
      font-weight: 700;
      font-size: 22px;
      line-height: 26px;
      text-align: center;
      color: #ffffff;
    }
    .message-footer {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      color: #ffffff;
      margin: 43px 20px 26px 20px;
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin: 43px 20px 18px 20px;
      }
      a {
        padding: 0 10px;
        margin-top: 12px;
      }
    }
  }
`;
